import React from 'react'
const { AttentionBox } = require('monday-ui-react-core')

interface ErrorProps {
    error: string
}

export const ErrorMessage: React.FC<ErrorProps> = ({error}) => {
    return (
        <section className='error-message'>

        <AttentionBox className="monday-style-attention-box_box" text={error} title="Attention" />
        </section>
    );
}
